/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForJiraServiceManagementInherited extends models.ServiceAccountCredentialsBaseForJiraServiceManagement {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForJiraServiceManagementInherited");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForJiraServiceManagementInherited.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForJiraServiceManagementInherited>): ServiceAccountCredentialsForJiraServiceManagementInherited {
        let obj = Object.assign(new ServiceAccountCredentialsForJiraServiceManagementInherited(), model);
        ServiceAccountCredentialsForJiraServiceManagementInherited.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForJiraServiceManagementInherited>): ServiceAccountCredentialsForJiraServiceManagementInherited {
        if (!model) return null;
        return ServiceAccountCredentialsForJiraServiceManagementInherited.newInstance(<ServiceAccountCredentialsForJiraServiceManagementInherited> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForJiraServiceManagementInherited) {
        if (!obj) return;

        models.ServiceAccountCredentialsForJiraServiceManagementInherited.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForJiraServiceManagementInherited): boolean {
        if (models.ServiceAccountCredentialsBaseForJiraServiceManagement.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForJiraServiceManagementInherited.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
